import React, { useRef } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const Factorization = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.FACTORIZATION }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.FACTORIZATION }}`;

  const mapData = ( value, index ) => {
    if ( 0 === index || 3 === index ) {
      return value.trim();
    } else {
      return value.split( '&' ).map( v => v.trim() );
    }
  };

  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '\\\\' ).map( mapData );

  const reduceChangedDataCount = ( result, value, index ) => {
    let count;
    switch ( index ) {
      case 1 :
      case 2 :
        count = value.filter( ( v, i ) => ( prevData.current[ index ] && prevData.current[ index ][ i ] ) !== v ).length;
        break;
      default :
        count = prevData.current[ index ] === value ? 0 : 1;
    }
    return result + count;
  };

  const changedDataCount = data.reduce( reduceChangedDataCount, 0 );

  const MathJaxNode = getMathJaxNode( props.type );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <div>
      <div className="ta-l"><MathJaxNode onRender={ renderMathJax }>{ data[ 0 ] }</MathJaxNode></div>
      <table className="tbl-factorization mt10">
        <tbody>
        <tr className="last">
          <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 1 ][ 0 ] }</MathJaxNode></span></td>
          <td className="va-m border_b" rowSpan="2"><img className="m05 va-tt" src={ `${ process.env.PUBLIC_URL }/static/images/common/ico_arrow1.svg` } alt="" /></td>
          <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 1 ][ 1 ] }</MathJaxNode></span></td>
          <td className="va-m"><img className="m05" src={ `${ process.env.PUBLIC_URL }/static/images/common/ico_arrow2.svg` } alt="" /></td>
          <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 1 ][ 2 ] }</MathJaxNode></span></td>
        </tr>
        <tr>
          <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 2 ][ 0 ] }</MathJaxNode></span></td>
          <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 2 ][ 1 ] }</MathJaxNode></span></td>
          <td className="va-m"><img className="m05" src={ `${ process.env.PUBLIC_URL }/static/images/common/ico_arrow2.svg` } alt="" /></td>
          <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 2 ][ 2 ] }</MathJaxNode></span></td>
        </tr>
        <tr className="last">
          <td className="ta-r pt5" colSpan="5"><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ data[ 3 ] }</MathJaxNode></span></td>
        </tr>
        </tbody>
      </table>
    </div>
  );

};

export default Factorization;
